import * as React from 'react';
import { GroupListGroup, GroupListColumnType, GroupList, GroupListColumn, GroupListItem, GroupListTitleColumn } from '../../interfaces/IGroupList';
import { IAIcon } from '../icon/Icon';
import * as styles from './GroupList.css';
import { IACheckbox } from '../checkbox/Checkbox'
import { IAToggle } from '../toggle/Toggle';
import { IATooltip } from '../tooltip/Tooltip';
import { IATextField } from '../textField/TextField';
import { IAButton } from '../button/Button';
import { ENTER_KEY_CODE, SPACEBAR_KEY_CODE } from '../../global/Constants';
import { LocalizationService } from '../../services/LocalizationService';

export interface IGroupListProps {
  highlightColor: string;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  groupsItem: GroupList;
  getUpdates: (items: any, selectedItem?: any, selectedGroup?: string) => void;
  onExpand?: (group: string, expanded: boolean) => void;
  hideHeader?: boolean;
}

export interface IGroupListState {
  groups: { [key: string]: boolean };
  mapReturn: { [key: string]: { [key: string]: { [key: string]: any } } };
  groupsItem: GroupList;
  selectedItem: any;
  selectedGroup: string;
}


export class IAGroupList extends React.Component<IGroupListProps, IGroupListState> {

  private localizationService: LocalizationService;

  constructor(props: IGroupListProps, state: IGroupListState) {
    super(props, state);
    this.localizationService = new LocalizationService();
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());

    let groups: { [key: string]: boolean } = {};
    let mapReturn: { [key: string]: { [key: string]: { [key: string]: boolean } } } = {};
    let selectedItem = {};
    if (props.groupsItem && props.groupsItem.groups) {
      props.groupsItem.groups.forEach((group) => {
        let items: { [key: string]: { [key: string]: boolean } } = {};
        groups[group.title] = group.expanded;
        group.items.forEach((item) => {
          let list: { [key: string]: boolean } = {};
          item.columns.forEach((column) => {
            list[column.title] = column.value;
          });
          items[item.id] = list;
        });
        if (group.clickableGroupTitle) {
          let list: { [key: string]: any } = {};
          group.groupValues.columns.forEach((column) => {
            list[column.title] = column.value;
          });
          items["header"] = list;
        }
        mapReturn[group.title] = items;
      });
    }

    this.state = {
      groups,
      mapReturn,
      groupsItem: props.groupsItem,
      selectedItem,
      selectedGroup: undefined
    };

  }

  public componentWillReceiveProps(newProps: IGroupListProps) {
    if (newProps.groupsItem !== this.props.groupsItem) {
      let groups = this.state.groups;
      let mapReturn: { [key: string]: { [key: string]: { [key: string]: any } } } = {};

      if (newProps.groupsItem.groups) {
        newProps.groupsItem.groups.forEach((group) => {
          let items: { [key: string]: { [key: string]: any } } = {};

          groups[group.title] = groups[group.title] ?? false;

          group.items.forEach((item) => {
            let list: { [key: string]: any } = {};
            item.columns.forEach((column) => {
              list[column.title] = column.value;
            });
            items[item.id] = list;
          });
          if (group.clickableGroupTitle) {
            let list: { [key: string]: any } = {};
            group.groupValues.columns.forEach((column) => {
              list[column.title] = column.value;
            });
            items["header"] = list;
          }
          mapReturn[group.title] = items;
        });
      }

      this.setState({
        groups,
        mapReturn,
        groupsItem: newProps.groupsItem
      });
    }
  }

  public render(): React.ReactElement<IGroupListProps> {
    if (!this.props.groupsItem) {
      return (<div></div>);
    }

    return (
      <div className={styles.rTable} style={this.props.style}>
        <div className={styles.rTableRow}>{this.getTableHeader(this.props.groupsItem.columns, this.state.groupsItem, this.props.groupsItem.nameFirstColumn)}</div>
        {this.state.groupsItem.groups.map((group) => {
          return this.getTableGroups(group, this.state.groupsItem.hideFirstColumn);
        })
        }
      </div>
    );
  }

  private getTableHeader = (columnTitles: GroupListTitleColumn[], groupList: GroupList, nameFirstColumn: string) => {
    if (this.props.hideHeader) {
      return [];
    } else {
      let header: JSX.Element[] = [];
      if (!groupList.hideFirstColumn) {
        header.push(
          <div
            className={styles.rTableHead}
            key={nameFirstColumn}
          >
            {nameFirstColumn}
          </div>
        );
      }

      header.push(...columnTitles.map((column) => {
        return (
          <div
            className={styles.rTableHead}
            key={column.title}
            style={{
              width: column.width,
              cursor: column.onClick ? "pointer" : undefined
            }}
            onClick={() => {
              if (column.onClick) {
                column.onClick();
                this.forceUpdate();
              }
            }}
          >
            {column.title}
          </div>
        );
      }));
      return header;
    }
  }

  private expandCollapseGroup = (group: GroupListGroup) => {
    if (this.state.groups[group.title] === undefined || this.state.groups[group.title] === null) {
      this.state.groups[group.title] = true;
    } else {
      this.state.groups[group.title] = !this.state.groups[group.title];
    }
    this.setState({ groups: this.state.groups });
    if (this.props.onExpand) {
      this.props.onExpand(group.title, this.state.groups[group.title]);
    }
  }

  private groupHeaderIconOnClick = (itemObject: { [key: string]: any }, column: GroupListColumn, group: GroupListGroup) => {
    if (itemObject[column.title] === undefined || itemObject[column.title] === null) {
      itemObject[column.title] = true;
    } else {
      itemObject[column.title] = !itemObject[column.title];
    }
    this.setState({ mapReturn: this.state.mapReturn, selectedItem: group.groupValues, selectedGroup: undefined }, this.returnChange);
  }

  private getTableGroupItemsIconOnClick = (itemObject: { [key: string]: any }, column: GroupListColumn, group: GroupListGroup, item: GroupListItem) => {
    if (itemObject[column.title] === undefined || itemObject[column.title] === null) {
      itemObject[column.title] = true;
    } else {
      itemObject[column.title] = !itemObject[column.title];
    }
    this.setState({ mapReturn: this.state.mapReturn, selectedItem: item, selectedGroup: group.title }, this.returnChange);
  }

  private getTableGroups = (group: GroupListGroup, hideFistColumn: boolean) => {
    const tableHeaderClass = [styles.rTableRow, styles.rTableRowHeader].join(' ');
    let groupHeader = (
      <div
        className={tableHeaderClass}
        key={group.title}>
        {!group.hideTitle &&
          <div className={styles.rTableCell}>
            <div>
              <div
                className={[styles.iconContainer, "IA_OnFocus"].join(" ")}
                tabIndex={group.items.length > 0 ? 0 : -1}
                onClick={() => this.expandCollapseGroup(group)}
                onKeyPress={(event) => {
                  if (event.which === ENTER_KEY_CODE || event.which === SPACEBAR_KEY_CODE) {
                    this.expandCollapseGroup(group);
                  }
                }}
              >
                {group.items && group.items.length > 0 &&
                  <div
                    className={styles.iconExpanded}
                    style={{
                      transform: !this.state.groups[group.title] ? "rotate(180deg)" : "rotate(0deg)"
                    }}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"
                      color={this.props.highlightColor}
                      size={19}
                      cursor="pointer"
                    />
                  </div>
                }
              </div>
              <div
                style={{
                  float: "left",
                  marginTop: 3
                }}
              >
                {group.title}
              </div>
              {group.toolTip
                ? <IATooltip
                  content="Tooltip"
                  type={"bubble"}
                  styles={{
                    width: 300,
                    textAlign: "left",
                    color: "#333333",
                    display: 'inline',
                    fontWeight: 'normal',
                  }}
                  rootStyles={{
                    float: 'none',
                    display: 'inline',
                  }}
                  componentContent={group.toolTip}
                >
                  <IAIcon
                    url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"
                    size={14}
                    color={"#03787c"}
                    style={{
                      marginLeft: 7,
                      height: 13,
                      display: 'inline',
                      float: "left"
                    }}
                  />
                </IATooltip>
                : ""}
            </div>
          </div>}
        {group.clickableGroupTitle &&
          this.clickableGroupHeader(group)
        }
      </div>
    );
    let groupTable: JSX.Element[] = [];
    groupTable.push(groupHeader);
    groupTable.push(...this.getTableGroupItems(group, hideFistColumn));
    return groupTable;
  }

  private clickableGroupHeader(group: GroupListGroup) {
    let line = (

      group.groupValues.columns.map((column) => {
        let element: JSX.Element;
        let itemObject = this.state.mapReturn[group.title]["header"];
        switch (column.type) {
          case GroupListColumnType.Switch:
            element = (
              <IAToggle
                label={""}
                checked={itemObject[column.title]}
                onChange={() => {
                  itemObject[column.title] = itemObject[column.title] !== undefined ? !itemObject[column.title] : false;
                  this.setState({ mapReturn: this.state.mapReturn }, this.returnChange);
                }}
                style={{
                  float: "left",
                  width: "unset"
                }}
                color={this.props.highlightColor}
                disabled={column.disabled}
              />
            );
            break;
          case GroupListColumnType.Checkbox:
            element = (
              <div
                className={styles.rTableCheckbox}
              >
                <IACheckbox
                  highlightColor={this.props.highlightColor}
                  isChecked={itemObject[column.title]}
                  onChange={() => {
                    // itemObject = this.state.mapReturn[group.title][item.title];
                    if (itemObject[column.title] === undefined || itemObject[column.title] === null) {
                      itemObject[column.title] = true;
                    } else {
                      itemObject[column.title] = !itemObject[column.title];
                    }
                    this.setState({ mapReturn: this.state.mapReturn }, this.returnChange);
                  }}
                />
              </div>
            );
            break;
          case GroupListColumnType.Icon:
            element = (
              <div
                className="IA_OnFocus"
                style={{ cursor: 'pointer', position: 'relative', top: '3px' }}
                tabIndex={0}
                onClick={() => this.groupHeaderIconOnClick(itemObject, column, group)}
                onKeyPress={(event) => {
                  if (event.which === ENTER_KEY_CODE || event.which === SPACEBAR_KEY_CODE) {
                    this.groupHeaderIconOnClick(itemObject, column, group);
                  }
                }}
              >
                <IAIcon
                  url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Edit/SVG/ic_fluent_edit_48_regular.svg"
                  color={this.props.highlightColor}
                  size={17}
                  cursor="pointer"
                />
              </div>
            );
            break;
          case GroupListColumnType.Text:
            element = (
              <div>
                {column.value}
              </div>
            );
            break;
          case GroupListColumnType.Component:
            element = (
              <div>
                {column.value}
              </div>
            );
            break;
        }
        return (<div className={styles.rTableCell} style={{ display: "table-cell" }}>
          {element}
        </div>);
      })

    );

    return line;
  }

  private returnChange = () => {
    this.props.getUpdates(this.state.mapReturn, this.state.selectedItem, this.state.selectedGroup);
  }

  private getTableGroupItems = (group: GroupListGroup, hideFistColumn: boolean) => {
    const tableContentClass = [styles.rTableRow, styles.rTableRowContent].join(' ');
    let lines: JSX.Element[] = [];
    group.items.forEach((item, index) => {
      let line = (
        <div
          className={tableContentClass}
          style={this.props.contentStyle}
          key={item.id}
        >
          {!hideFistColumn && <div className={`${styles.rTableCell}`} style={{ display: (this.state.groups[group.title]) ? "table-cell" : "none" }}>
            <div className={styles.rTableCell2} >
              <div style={{ float: "left" }}>{item.title}</div>
              {item.columns[0].toolTip &&
                <div style={{ marginTop: "-8px", marginLeft: "10px", marginBottom: "-15px", float: "left" }}>
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      color: "#999999",
                      textAlign: "center",
                      marginBottom: "5px"
                    }}
                    componentContent={item.columns[0].toolTip}>
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"
                      size={17}
                      color={this.props.highlightColor}
                      style={{
                        marginTop: "11px"
                      }} />
                  </IATooltip>
                </div>
              }
            </div>
          </div>}
          {
            item.columns.map((column) => {
              let element: JSX.Element;
              let itemObject = this.state.mapReturn[group.title][item.id];
              switch (column.type) {
                case GroupListColumnType.Switch:
                  element = (
                    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                      <IAToggle
                        label={""}
                        checked={itemObject[column.title]}
                        disabled={column.disabled}
                        onChange={() => {
                          itemObject[column.title] = itemObject[column.title] !== undefined ? !itemObject[column.title] : false;
                          this.setState({ mapReturn: this.state.mapReturn, selectedItem: item, selectedGroup: group.title }, this.returnChange);
                        }}
                        style={{
                          float: "left",
                          width: "unset",
                          marginRight: "10px"
                        }}
                        color={this.props.highlightColor}
                      />
                    </div>
                  );
                  break;
                case GroupListColumnType.Checkbox:
                  element = (
                    <div
                      className={styles.rTableCheckbox}
                    >
                      <IACheckbox
                        highlightColor={this.props.highlightColor}
                        isChecked={itemObject[column.title]}
                        onChange={() => {
                          // itemObject = this.state.mapReturn[group.title][item.title];
                          if (itemObject[column.title] === undefined || itemObject[column.title] === null) {
                            itemObject[column.title] = true;
                          } else {
                            itemObject[column.title] = !itemObject[column.title];
                          }
                          this.setState({ mapReturn: this.state.mapReturn, selectedItem: item, selectedGroup: group.title }, this.returnChange);
                        }}
                      />
                    </div>
                  );
                  break;
                case GroupListColumnType.Icon:
                  element = (
                    <div
                      className="IA_OnFocus"
                      tabIndex={0}
                      style={{ cursor: 'pointer', position: 'relative', top: '3px' }}
                      onClick={() => this.getTableGroupItemsIconOnClick(itemObject, column, group, item)}
                      onKeyPress={(event) => {
                        if (event.which === ENTER_KEY_CODE || event.which === SPACEBAR_KEY_CODE) {
                          this.getTableGroupItemsIconOnClick(itemObject, column, group, item);
                        }
                      }}
                    >
                      <IAIcon
                        url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Edit/SVG/ic_fluent_edit_48_regular.svg"
                        color={this.props.highlightColor}
                        size={17}
                        cursor="pointer"
                      />
                    </div>
                  );
                  break;
                case GroupListColumnType.Text:
                  element = (
                    <div
                      className={styles.textNewLine}
                      style={{
                        paddingLeft: column.title === new LocalizationService().strings.TargetingAdmin_ApplicationColumnName ? 50 : 0,
                      }}
                    >
                      {column.value}
                    </div>
                  );
                  break;
                case GroupListColumnType.TextField:
                  element = (
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                      <IATextField
                        key="textfield"
                        text={column.value}
                        style={{ marginTop: "-5px", marginRight: "10px" }}
                        onChange={(text: string) => {
                          itemObject[column.title] = text;
                        }}
                      />
                      <IAButton
                        key="textfield_button"
                        onClick={() => {
                          this.setState({ mapReturn: this.state.mapReturn, selectedItem: item, selectedGroup: group.title }, this.returnChange);
                        }}
                        label={this.localizationService.strings.AdvancedSettings_save}
                        buttonColor={this.props.highlightColor}
                        disbaled={column.disabled}
                      />
                    </div>
                  );
                  break;
                case GroupListColumnType.Component:
                  element = (
                    <div>
                      {column.value}
                    </div>
                  );
                  break;
              }
              return (
                <div className={styles.rTableCell} style={{
                  display: (this.state.groups[group.title]) ? "table-cell" : "none",
                }}
                >
                  {element}
                </div>)
                ;
            })
          }
        </div>
      );
      lines.push(line);
      if (group.borderEveryItem) {
        let emptyLine = (
          <div
            className={styles.rTableRow}
            key={"emptyLine_" + index}
          >
            {!hideFistColumn && <div className={styles.rTableFooter} />}
            {this.state.groupsItem.columns.map(() => {
              return (<div className={styles.rTableFooter} />);
            })}
          </div>);
        lines.push(emptyLine);
      }
    });
    if (!group.borderEveryItem) {
      let emptyLine = (
        <div className={styles.rTableRow} key={"emptyLine"}>
          {!hideFistColumn && <div className={styles.rTableFooter} />}
          {this.state.groupsItem.columns.map(() => {
            return (<div className={styles.rTableFooter} />);
          })}
        </div>);
      lines.push(emptyLine);
    }
    return lines;
  }
}


